import Tab from "./Tab"
import Panel from "./TabPanel"

export default Object.assign(Tab, { Panel })
